<ng-container *accessController="['SDoHOperations']">
  <ng-container *accessView="['SDoHQueue.Read']">
    <div class="p-4">
      <div class="mb-2">
        <app-queue-action-buttons>
          <ng-container queue-action>
            <div class="flex items-center show-highlighted">
              <p-toggle-switch
                styleClass="toggle-sm"
                [style]="{ height: '20px' }"
                [(ngModel)]="showHighlighted"
                name="showHighLightedControl"
                ngDefaultControl
                data-test-id="highlighted-switch">
              </p-toggle-switch>
              <span>Show only items requiring attention</span>
            </div>
          </ng-container>
        </app-queue-action-buttons>
      </div>
      <mnc-sdoh-queue
        lazyComponent
        [showHighlighted]="showHighlighted"
        (memberClicked)="memberClicked($event)"
        (referralNumberClicked)="referralNumberClicked($event)"
        (showHighlightedChange)="showHighlightedChanged($event)" />
    </div>
  </ng-container>
</ng-container>
